import React, { useState } from 'react';
import axios from '../../axios-backend';
import Line from '../main/Line';
import Button from '../main/Button';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as actionTypes from '../../store/actions';

const md5 = require('md5');

const Admin = ({ onUserLogin }) => {
  const [username, setUsername] = useState('');
  const [pwd, setPwd] = useState('');
  const navigate = useNavigate();

  const handleSubmit = e => {
    e.preventDefault();
    const user = md5(username);
    const pass = md5(pwd);
    axios.post('/admin', {
      user, pass
    }).then(data => {
      if (data.data.status === "success") {
        onUserLogin(data.data.userName);
        sessionStorage.setItem("user", data.data.userName);
        navigate('/admin-home');
      } else {
        alert('get out of here!');
      }
    });
  };

  return (
    <form onSubmit={handleSubmit} style={{ height: "100%" }}>
      <Line type="bottom-line" style={{ justifyContent: "center" }}>Wonwonleywon Admin Panel</Line>
      <Line type="bottom-line" style={{ placeContent: "center" }}>
        <label htmlFor="username" style={{ marginRight: "1rem" }}>username:</label>
        <input type="text" name="username" value={username} onChange={e => setUsername(e.target.value)} /> <br />
      </Line>
      <Line type="bottom-line" style={{ placeContent: "center" }}>
        <label htmlFor="password" style={{ marginRight: "1rem" }}>password:</label>
        <input type="text" name="password" value={pwd} onChange={e => setPwd(e.target.value)} />
      </Line>
      <Line type="bottom-line" style={{ placeContent: "center" }}>
        <Button type="submit" >
          Login
        </Button>
      </Line>
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
      <Line type="bottom-line" />
    </form>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    onUserLogin: (username) => dispatch({ type: actionTypes.USERLOGIN, username })
  };
}
export default connect(null, mapDispatchToProps)(Admin);
